import { render, staticRenderFns } from "./UserDocuments.vue?vue&type=template&id=2eb7340f&scoped=true"
import script from "./UserDocuments.vue?vue&type=script&lang=js"
export * from "./UserDocuments.vue?vue&type=script&lang=js"
import style0 from "./UserDocuments.vue?vue&type=style&index=0&id=2eb7340f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb7340f",
  null
  
)

export default component.exports